module.exports = __webpack_public_path__ + "media/video1.18f5ca20.mp4";